import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchRecommendedJobs } from "./RecommendedJobsAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchRecommendedJobsAsync = createAsyncThunk(
  "RecommendedJobs/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchRecommendedJobs();

      const resp = data?.response;
      if (!resp) {
        throw new Error("Invalid response structure");
      }
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const RecommendedJobsSlice = createSlice({
  name: "RecommendedJobs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecommendedJobsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecommendedJobsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("data", action.payload);
        state.error = null;
      })
      .addCase(fetchRecommendedJobsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectRecommendedJobs = (state) => state.recommendedJobs.data;

export default RecommendedJobsSlice.reducer;
